// Navigation Menu
// 

JLM.MD.Menu = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// Menu parts
	let bar_small, bar_large, bar_large_ref, menu_popout, menu_search, menu_shortlist, overlay;
	
	// Settings
	let status = container.attr('data-status'),
		focus = container.attr('data-focus');
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let nav_bar;
		
		// Construct modules
		nav_bar = $('.nav_bar', container);
		bar_large_ref = $('.bar_large', nav_bar);
		bar_small = new JLM.MD.MenuBarSmall( $('.bar_small', nav_bar) );
		bar_large = new JLM.MD.MenuBarLarge( bar_large_ref );
		menu_popout = $('.nav_popout', container);
		menu_search = new JLM.MD.MenuSearch( menu_popout );
		menu_shortlist = new JLM.MD.MenuShortlist( menu_popout );
		overlay = $('<div class="nav_overlay" />').appendTo( container );
		
		// Set tally
		onShortlistTallyUpdate( menu_shortlist.tally );
		
		// Events
		bar_small.on('mouseover', onMouseOver);
		bar_small.on('mouseout', onMouseOut);
		bar_small.on('toggle_menu', toggleMenu);
		bar_small.on('navigate_contact', navigateToContact);
		bar_small.on('toggle_search', toggleSearch);
		bar_small.on('toggle_shortlist', toggleShortlist);
		bar_large.on('navigate_contact', navigateToContact);
		bar_large.on('toggle_search', toggleSearch);
		bar_large.on('toggle_shortlist', toggleShortlist);
		menu_shortlist.on('update_tally', onShortlistTallyUpdate);
		menu_shortlist.on('remove', onRemoveFromShortlist);
		menu_shortlist.on('empty', onEmptyShortlist);
		overlay.on('click', onClickOverlay);
		container.on('mousewheel', onScroll);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Event: Mouse interaction
	// 
	function onMouseOver() {
		container.addClass('hover');
	}
	function onMouseOut() {
		container.removeClass('hover');
	}
	
	
	// Event: Overlay events
	// 
	function onClickOverlay( event ) {
		if ( $(event.target)[0] == overlay[0] ) {
			INSTANCE.close();
		}
	}
	
	
	// Event: Scrolling
	// 
	function onScroll( event ) {
		const target = $(event.target);
		if ( target[0] == overlay[0] || target.closest( bar_large_ref ).length ) {
			event.preventDefault();
		}
	}
	
	
	// Show: Navigation Options
	// 
	function toggleMenu() {
		if ( focus == 'menu' ) INSTANCE.close();
		else expandMenuNavigation();
	}
	function expandMenuNavigation() {
		bar_small.selectMenu();
		bar_large.selectMenu();
		INSTANCE.open();
		focus = 'menu';
		container.attr('data-focus', focus);
	}
	
	
	// Hide current popout
	// 
	function closeCurrentPopout() {
		bar_small.unselect();
		bar_large.unselect();
		focus = '';
		container.attr('data-focus', focus);
		menu_popout.attr('data-status', 'closed');
		menu_shortlist.close();
	}
	
	
	// Go to Contact page
	// 
	function navigateToContact() {
		window.location.assign('/contact');
	}
	
	
	// Show: Quick Search feature
	// 
	function toggleSearch() {
		if ( focus == 'search' ) closeCurrentPopout();
		else expandMenuSearch();
	}
	function expandMenuSearch() {
		JLM.database.loadTalentList('search', function() {});
		bar_small.selectSearch();
		bar_large.selectSearch();
		INSTANCE.open();
		focus = 'search';
		container.attr('data-focus', focus);
		menu_popout.attr('data-status', 'open');
		setTimeout(menu_search.focus, 150);
	}
	
	
	// Show: Shortlist feature
	// 
	function toggleShortlist() {
		if ( focus == 'shortlist' ) {
			if ( JLM.MT.getLayout() == JLM.NS.LAYOUT_SMALL ) {
				INSTANCE.close();
			} else {
				closeCurrentPopout();
			}
		} else expandMenuShortlist();
	}
	function expandMenuShortlist() {
		bar_small.selectShortlist();
		bar_large.selectShortlist();
		INSTANCE.open();
		focus = 'shortlist';
		container.attr('data-focus', focus);
		menu_popout.attr('data-status', 'open');
	}
	
	
	// Update shortlist tally
	// 
	function onShortlistTallyUpdate( tally, is_setup ) {
		bar_small.updateShortlistTally( tally, is_setup );
		bar_large.updateShortlistTally( tally );
	}
	function onRemoveFromShortlist() {
		INSTANCE.dispatchEvent('shortlist_remove', [].slice.call( arguments ));
	}
	function onEmptyShortlist() {
		INSTANCE.dispatchEvent('shortlist_empty');
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Open / Close
	// 
	INSTANCE.open = function() {
		status = 'open';
		container.attr('data-status', status);
		INSTANCE.dispatchEvent('open');
	};
	INSTANCE.close = function() {
		status = 'closed';
		container.attr('data-status', status);
		focus = '';
		container.attr('data-focus', focus);
		bar_small.unselect();
		bar_large.unselect();
		menu_popout.attr('data-status', 'closed');
		menu_shortlist.close();
		INSTANCE.dispatchEvent('close');
	};
	INSTANCE.toggle = function() {
		if ( status == 'closed' ) INSTANCE.open();
		else INSTANCE.close();
	};
	
	
	// Add talent to Shortlist
	// 
	INSTANCE.addToShortlist = function( talent_id, division_type ) {
		menu_shortlist.add( talent_id, division_type );
	};
	
	// Remove talent from Shortlist
	// 
	INSTANCE.removeFromShortlist = function( talent_id, division_type ) {
		menu_shortlist.remove( talent_id, division_type );
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};